import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { chatbotApi } from '../../../common/src';
import { v4 as uuidv4 } from 'uuid';
import { FaBeer } from 'react-icons/fa';
const WidgetCategory = (props) => {
  const [categoryList, setCategoryList] = useState();

  const _getCategory = async () => {
    const result = await axios.get(chatbotApi + '/api/getCategory');
    const intReturn = result.data.intReturn;
    if (intReturn === 0) {
      setCategoryList(result.data.listData);
    }
  };
  const _itemClick = (categoryCode, categoryName) => {
    const sessionKey = uuidv4();
    //console.log(sessionKey);
    // //console.log(props);
    // //console.log(sessionKey);

    // props.setState((prev) => {
    //   return { ...prev, sessionKey: sessionKey };
    // });

    props.actionProvider._categorySelect(
      categoryCode,
      categoryName,
      sessionKey
    );
  };
  const _etc = () => {
    const sessionKey = uuidv4();
    props.actionProvider._selectEtc('기타문의', sessionKey);
  };
  const _qna = () => {
    const sessionKey = uuidv4();
    props.actionProvider._selectQna('1 : 1 문의하기', sessionKey);
  };
  const _chat = () => {
    const sessionKey = uuidv4();
    const box = document.querySelector('body');
    const hbox = box.offsetHeight;
    document.getElementsByClassName(
      'react-chatbot-kit-chat-input-container'
    )[0].style.display = '';
    if (hbox <= 667) {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = hbox - 200 + 'px';
    } else {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = '540px';
    }

    props.actionProvider._selectChat('채팅으로 문의하기', sessionKey);
  };
  const _end = () => {
    props.actionProvider._end();
  };
  useEffect(() => {
    _getCategory();
  }, []);
  return (
    <>
      <div className="widget-container">
        {/* <div className="">
          <div className="widget-title">아래의 내용을 찾으셨나요?</div>
        </div> */}

        <ul className="widget-content">
          {categoryList &&
            categoryList.map((item) => (
              <li
                key={item.categoryCode}
                onClick={() => _itemClick(item.categoryCode, item.categoryName)}
              >
                <img src={'/img/chatbot/' + item.icon} />
                {item.categoryName}
              </li>
            ))}
          {/* <li onClick={_etc}>기타문의</li> */}
          <li onClick={_qna}>
            <img src="/img/chatbot/icon_qna.png" />1 : 1 게시판 문의
          </li>
          <li onClick={_chat}>
            <img src="/img/chatbot/icon_chat.png" />
            채팅으로 문의
          </li>
          <li onClick={_end}>
            <img src="/img/chatbot/icon_exit.png" />
            문의종료(나가기)
          </li>
        </ul>
      </div>

      {/* <div className="widget-time">{props.payload.writetime}</div> */}
    </>
  );
};
export default WidgetCategory;
